import styled from "styled-components";
export const Styles = styled.div`
  .cont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .floating-card {
    box-shadow: -1px 5px 3px #46454745;
    border: none;
    padding-block: 20px;
    padding-inline: 75px;
    transform: translateY(30%);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 80px;
    width: 650px;
    padding: 20px 40px 0px 40px;
  }
  .data {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
  .course-main-data {
    display: flex;
    gap: 10px;
  }
  @media (max-width: 768px) {
    .course-main-data {
      flex-direction: column;
    }
  }
  .floating-card .course-img {
    width: 250px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .floating-card .course-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .floating-card .course-data {
    ${(props) => (props.courseImg ? `width: 75%;` : `width: 100%;`)};
    height: 150px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
  }
  .floating-card .course-data .data-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .floating-card .course-data .data-header .title {
    color: #000 !important;
  }
  .floating-card .course-data .data-header .courses {
    font-size: 12px;
  }
  .floating-card .course-data .course-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--dark-color);
    .name {
      /* width: 100%; */
      width: 295px;
      /* overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis; */
      text-align: start;
    }
  }
  /* @media (max-width: 768px) {
    .floating-card .course-data .course-name .name {
      width: 250px;
    }
  } */
  /* .floating-card .course-data .course-name  */
  .floating-card .course-data .course-name .course {
    width: 40px;
    height: 40px;
    border: 1px solid var(--dark-color);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: 0.3s;
  }
  .floating-card .course-data .course-name .course:hover {
    background: var(--dark-purple);
    color: #fff !important;
  }
  .floating-card .course-data .course-progress {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .floating-card .course-data .course-progress .progress-par {
    position: relative;
    width: 80%;
    height: 3px;
    background: var(--dark-purple);
    border-radius: 5px;
  }
  .floating-card
    .course-data
    .course-progress
    .progress-par
    .progress-par-fill {
    position: absolute;
    height: 3px;
    border-radius: 5px;
    background: var(--blue);
  }
  .floating-card
    .course-data
    .course-progress
    .progress-par
    .progress-par-fill::after {
    position: absolute;
    content: "";
    background: #fff;
    height: 8px;
    width: 8px;
    border: 1px solid var(--light-purple);
    border-radius: 50%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .floating-card .course-data .course-progress .progress-percent {
    font-size: 12px;
    padding-inline-end: 10px;
  }
  @media (max-width: 768px) {
    .floating-card {
      flex-direction: column;
      transform: translateY(0%);
      padding: 20px 40px 0px 40px;
      gap: 20px;
      width: 350px;
    }
    .floating-card .course-data {
      font-size: 15px;
      width: 100%;
      height: 100px;
    }
    .floating-card .course-data .course-name .name {
      width: 240px;
    }
  }
`;
